import React from "react"
import { Link } from "react-router-dom"

import "./scss/main.scss"

const Copyright = () => (
  <div id="copyright-container">
    <div className="container">
      <div id="copyright" className="row">
        <div className="col-6">
          <p>
            Développement : <a href="https://www.h3d.fr" target="_blank" rel="noreferrer" title="H3D">H3D</a><br />
            <Link to="/CGU">Conditions générales d'utilisation</Link>
          </p>
        </div>
        <div className="col-6 text-end">
          <p>© DROPCV {}</p>
        </div>
      </div>
    </div>
  </div>
)

export default Copyright
